import React from 'react';

export const Iphone = ({ className }) => {
  return (
    <svg viewBox="0 0 62 130" fill="none" className={className}>
      <path
        d="M42.9131 6.75878L42.9151 6.75878C43.9861 6.75771 45.0133 6.33217 45.7711 5.57499C46.529 4.81775 46.9555 3.79067 46.9566 2.71904C46.9566 2.708 46.961 2.69706 46.9693 2.68872C46.9777 2.68038 46.9893 2.67537 47.0018 2.67529H55.1728C56.2687 2.67675 57.3189 3.11237 58.0933 3.8861C58.8679 4.66002 59.3033 5.70897 59.3045 6.80271V123.178C59.3033 124.272 58.8679 125.32 58.0933 126.094L59.5069 127.509L58.0933 126.094C57.3187 126.868 56.2681 127.304 55.1718 127.305H6.13262C5.0364 127.304 3.98577 126.868 3.21114 126.094L1.79753 127.509L3.21113 126.094C2.4368 125.321 2.00145 124.272 2 123.179V6.80173C2.00145 5.70834 2.4368 4.65979 3.21114 3.88611C3.98553 3.11237 5.03578 2.67675 6.13164 2.67529H14.3026C14.3151 2.67537 14.3268 2.68039 14.3351 2.68872C14.3435 2.69705 14.3478 2.70799 14.3479 2.71903C14.3489 3.79067 14.7755 4.81775 15.5334 5.57499C16.2912 6.33217 17.3184 6.75771 18.3893 6.75878H18.3913L42.9131 6.75878Z"
        fill="white"
        stroke="#2A4365"
        strokeWidth="4"
      />
    </svg>
  );
};
